import { render, staticRenderFns } from "./ListenerQueueDetails.vue?vue&type=template&id=54d3fbf0&scoped=true"
import script from "./ListenerQueueDetails.vue?vue&type=script&lang=js"
export * from "./ListenerQueueDetails.vue?vue&type=script&lang=js"
import style0 from "./ListenerQueueDetails.vue?vue&type=style&index=0&id=54d3fbf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d3fbf0",
  null
  
)

export default component.exports